import { FunctionComponent } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

interface IntlPhoneInputProps {
  value: string;
  onChange: (e: string) => any;
  name: string;
}

const IntlPhoneInput: FunctionComponent<IntlPhoneInputProps> = ({ value, onChange, name }) => {
  return (
    <PhoneInput
      defaultCountry="US"
      international
      withCountryCallingCode
      value={value || ""}
      onChange={onChange}
      data-name={name}
    />
  );
};

export default IntlPhoneInput;
